import * as React from 'react';
import { connect } from 'react-redux';
import { FindAPDAppState } from '../classes/redux-states';
import { Dispatch } from 'redux';
import { IAAPDDentist } from '../classes/dentist';
import { ActionType, setContent } from '../redux/actions/actions';

export interface ExternalProps {
    dentist: IAAPDDentist;
}

interface DispatchToProps {
    setContent: (content: IAAPDDentist) => any;
}

export interface StateToProps {
    zipCode: string;
}

interface DentistItemState {
}

type DentistItemProps = ExternalProps & DispatchToProps & StateToProps;

export class DentistItemComponent extends React.Component<DentistItemProps, DentistItemState> {
    constructor(props: DentistItemProps) {
        super(props);
    }

    getDistanceToDisplay() {
        if (this.props.zipCode == null)
            return false;
        else if (this.props.zipCode == "")
            return false;
        else
            return true;
    }

    render() {
        return (
            <li className="find-a-pd-results-list-item">
                <div className="find-a-pd-results-list-item-content">
                    <h4 className="find-a-pd-results-list-item-title">{this.props.dentist.dentistName}</h4>

                    <div className="find-a-pd-results-list-item-info">
                        <p className="">{this.props.dentist.officeName}</p>
                        <p className="">{this.props.dentist.officeAddressLine1}</p>
                        <p className="">{this.props.dentist.officeAddressLine2}</p>
                        <p className="">{this.props.dentist.officeAddressCountry}</p>
                    </div>

                    <div className="find-a-pd-results-list-item-info find-a-pd-results-list-item-info-optional">
                        {
                            this.props.dentist.officePhone != null ? <p><strong>Ph: </strong>{this.props.dentist.officePhone}</p> : null
                        }
                        {
                            this.props.dentist.officeFax != "" ? <p><strong>Fax: </strong>{this.props.dentist.officeFax}</p> : null
                        }
                        {
                            this.props.dentist.officeWebsite != null ? <a href={this.props.dentist.officeWebsite} target="_blank">{this.props.dentist.officeWebsite}</a> : null
                        }
                    </div>
                    <div className="find-a-pd-results-filter-approx">
                        
                        {
                            this.getDistanceToDisplay() ? <p>Approximately <span>{this.props.dentist.officeDistanceFromZip} miles</span> from the middle of your zip code.</p> : null
                        }
                        
                        
                    </div>
                </div>

                <div className="find-a-pd-results-list-item-link">
                    <a href={this.props.dentist.googleMapsLink} target="_blank">View Map</a>
                </div>
            </li>
        )
    }
}

function mapStateToProps(state: FindAPDAppState): StateToProps {
    return {
        zipCode: state.findAPDFiltersModel.zipCode
    }
}

function mapDispatchToProps(dispatch: Dispatch<FindAPDAppState>, ownProps: ExternalProps): DispatchToProps {
    return {
        setContent: (content: IAAPDDentist) => dispatch(setContent(content))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DentistItemComponent)


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/findapd/components/dentist-item.tsx